import { ADDRESSES, ZERO_ADDR } from '@/lib/contracts'


/// Reserve key -> the ADDRESSES key of the module defending that reserve, BY CONVENTION rather
/// than by a maintained map: deployLocal records every module as SAFETY_MODULE_<RESERVE ID>, with
/// both sides derived from config/reserves.json - so a newly listed reserve's Guardian Pool
/// appears here without touching this file. The one exception is spelled out: the 'eth' display
/// key maps to the WETH module for the same reason it maps to the WETH asset everywhere else -
/// the reserve IS WETH, 'eth' is how a user thinks about it (see useProtocolState's own comment).
const moduleKeyFor = (key) => `SAFETY_MODULE_${(key === 'eth' ? 'weth' : key).toUpperCase()}`

/// The Guardian Pools that actually exist: one SafetyModule per reserve (CHANGELOG.md entry 165),
/// paired here with the live reserve entry so a consumer has the module address AND the asset's
/// decimals/price/sToken in one object. A reserve with no deployed module (zero address, or an
/// ADDRESSES key that does not exist) simply contributes nothing - the UI renders what is real,
/// the same rule the reserve list itself follows. Facilitators are skipped by construction: hUSD
/// has no module because a facilitator's sToken supply is permanently zero.
export function guardianPools(reserves) {
  return (reserves ?? [])
    .filter((r) => !r.isFacilitator)
    .map((r) => ({ reserve: r, module: ADDRESSES[moduleKeyFor(r.key)] }))
    .filter((p) => p.module && p.module.toLowerCase() !== ZERO_ADDR)
}
